(function(){
  'use strict';

  var base=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
  if(base.charAt(base.length-1)!=='/')base+='/';
  var queued=false;
  var pending={};
  var dynamicCache={};

  var IMAGE_MAP={
    'iPhone 6':'https://cdn.shopify.com/s/files/1/0965/3977/1212/files/iphone-6-gris-sideral-xphones_5d165a83-2e31-413c-a543-821b2de2a687.jpg?v=1788095022',
    'iPhone 7':'https://cdn.shopify.com/s/files/1/0965/3977/1212/files/iphone-7-noir-de-jais-xphones_97d40dc1-1a5d-458d-a0ec-44ab4ffc83b2.jpg?v=1788094931',
    'iPhone 7 Plus':'https://cdn.shopify.com/s/files/1/0965/3977/1212/files/iphone-7-plus-or-xphones_10b8f42c-9a0e-4950-9488-95179468ab9c.png?v=1788094945',
    'iPhone 8':'https://cdn.shopify.com/s/files/1/0965/3977/1212/files/iphone-8-gris-sideral-xphones_e29a6078-b323-4c8a-bdee-cc83bdfe917b.jpg?v=1788094820',
    'iPhone 8 Plus':'https://cdn.shopify.com/s/files/1/0965/3977/1212/files/iphone-8-plus-argent-xphones_a7013ab3-9f2d-4d4f-bb6a-70555b76145d.png?v=1788094833',
    'iPhone X':'https://cdn.shopify.com/s/files/1/0965/3977/1212/files/iphone-x-argent-xphones_84040662-4930-41b1-a938-6308a04f359b.webp?v=1788094686',
    'iPhone XR':'https://cdn.shopify.com/s/files/1/0965/3977/1212/files/iphone-xr-corail-xphones_71737d9b-1121-4fd8-bc7f-e2ea72c09fff.webp?v=1788094702',
    'iPhone XS':'https://cdn.shopify.com/s/files/1/0965/3977/1212/files/iphone-xs-or-xphones_90a0fddf-25f1-4f68-a297-17b8fc4c0b2a.jpg?v=1788094711',
    'iPhone XS Max':'https://cdn.shopify.com/s/files/1/0965/3977/1212/files/iphone-xs-max-argent-xphones_035f2aba-3d3c-47f8-8cec-79515a767032.jpg?v=1788094718',
    'iPhone SE (2016)':'https://cdn.shopify.com/s/files/1/0965/3977/1212/files/iphone-se-2016-or-rose-xphones_d0048114-0051-4499-a3c8-b5db59b84c70.jpg?v=1787743930',
    'iPhone SE (2020)':'https://cdn.shopify.com/s/files/1/0965/3977/1212/files/iphone-se-2020-rouge-xphones_5bf5f193-03e6-44c9-996f-50cff409c216.jpg?v=1787743920',
    'iPhone SE (2022)':'https://cdn.shopify.com/s/files/1/0965/3977/1212/files/iphone-se-2022-minuit-grand_12d935a9-dc02-4906-98de-9764f92e7a9a.jpg?v=1787752673',
    'iPhone 11':'https://cdn.shopify.com/s/files/1/0965/3977/1212/files/iphone-11-mauve-xphones_5e71f167-8448-4844-bc51-6fa11f4ae29c.jpg?v=1788094570',
    'iPhone 11 Pro':'https://cdn.shopify.com/s/files/1/0965/3977/1212/files/iphone-11-pro-vert-nuit-xphones_052513b2-13aa-4782-ac5e-71f124d09a8f.jpg?v=1788094599',
    'iPhone 11 Pro Max':'https://cdn.shopify.com/s/files/1/0965/3977/1212/files/iphone-11-pro-max-argent-xphones_fc7d36d2-186d-435c-a813-07a8a8060044.jpg?v=1788094607',
    'iPhone 12':'https://cdn.shopify.com/s/files/1/0965/3977/1212/files/maxpromo-reparation-iphone-12-bleu-studio.png?v=1789490827',
    'iPhone 12 mini':'https://cdn.shopify.com/s/files/1/0965/3977/1212/files/iphone-12-mini-mauve-grand_1d3cc2cc-d405-4538-8877-1197cac68a5f.jpg?v=1788094457',
    'iPhone 12 Pro':'https://cdn.shopify.com/s/files/1/0965/3977/1212/files/iphone-12-pro-bleu-pacifique-xphones_47240996-5515-4ca2-8a83-2abdc0a6662f.jpg?v=1788094466',
    'iPhone 12 Pro Max':'https://cdn.shopify.com/s/files/1/0965/3977/1212/files/iphone-12-pro-max-or-xphones_0ed50ba1-d8f3-4121-811e-6a4f5ed9a21a.png?v=1788094476',
    'iPhone 13':'https://cdn.shopify.com/s/files/1/0965/3977/1212/files/maxpromo-reparation-iphone-13-rose-studio-final.png?v=1789499923',
    'iPhone 13 mini':'https://cdn.shopify.com/s/files/1/0965/3977/1212/files/iphone-13-mini-centered-xphones.png?v=1788119054',
    'iPhone 13 Pro':'https://cdn.shopify.com/s/files/1/0965/3977/1212/files/maxpromo-reparation-iphone-13-pro-bleu-studio.png?v=1789490842',
    'iPhone 13 Pro Max':'https://cdn.shopify.com/s/files/1/0965/3977/1212/files/iphone-13-pro-max-vert-alpin-grand_43e15c77-93cd-4579-8821-b9437c1c7dd1.jpg?v=1787752182',
    'iPhone 14':'https://cdn.shopify.com/s/files/1/0965/3977/1212/files/iphone-14-bleu-maxpromo.png?v=1788088879',
    'iPhone 14 Plus':'https://cdn.shopify.com/s/files/1/0965/3977/1212/files/iphone-14-plus-jaune-grand_37f249c9-4a7c-449f-bb89-408c90d8570d.jpg?v=1787751642',
    'iPhone 14 Pro':'https://cdn.shopify.com/s/files/1/0965/3977/1212/files/iphone-14-pro-violet-intense-grand_04717e09-2e32-4a67-9aed-c610a052d8bb.jpg?v=1787751955',
    'iPhone 14 Pro Max':'https://cdn.shopify.com/s/files/1/0965/3977/1212/files/iphone-14-pro-max-or-grand_3b906a14-3d29-4dc9-bc8f-83d19855233b.jpg?v=1787752065',
    'iPhone 15':'https://cdn.shopify.com/s/files/1/0965/3977/1212/files/iphone-15-vert-large_1a242ff9-2ae6-4b11-9185-f8927fc17acb.png?v=1787748498',
    'iPhone 15 Plus':'https://cdn.shopify.com/s/files/1/0965/3977/1212/files/iphone-15-plus-rose-large_d2e58648-54b4-4693-a793-73ac0be4900f.jpg?v=1787750465',
    'iPhone 15 Pro':'https://cdn.shopify.com/s/files/1/0965/3977/1212/files/iphone-15-pro-titane-naturel-large_03fbb3b2-6bb5-4224-9fae-f3627680db44.jpg?v=1787751005',
    'iPhone 15 Pro Max':'https://cdn.shopify.com/s/files/1/0965/3977/1212/files/iphone-15-pro-max-titane-bleu-large_b791922f-1172-4b82-b345-15c439f951ee.jpg?v=1787750542',
    'iPhone 16':'https://cdn.shopify.com/s/files/1/0965/3977/1212/files/iphone-16-sarcelle-large_332a3883-f5d0-46fa-8494-f16d64684695.png?v=1787739500',
    'iPhone 16 Plus':'https://cdn.shopify.com/s/files/1/0965/3977/1212/files/iphone-16-plus-rose-xphones_66606537-8486-416f-ba59-db07a1474e7b.jpg?v=1787740125',
    'iPhone 16e':'https://cdn.shopify.com/s/files/1/0965/3977/1212/files/iphone-16e-blanc-xphones_091f4a9c-8ac9-433c-b00b-2b4d95e8beb5.jpg?v=1787941743',
    'iPhone 16 Pro':'https://cdn.shopify.com/s/files/1/0965/3977/1212/files/iphone-16-pro-titane-noir-large_311fe2ac-97a5-488a-81af-c78e0e428ca6.jpg?v=1787750880',
    'iPhone 16 Pro Max':'https://cdn.shopify.com/s/files/1/0965/3977/1212/files/iphone-16-pro-max-titane-naturel-large_de5891b5-6d7b-4a8a-b1ea-81cb0d8834fe.jpg?v=1787750354'
  };

  function norm(value){
    var out=String(value||'').trim().toLowerCase();
    try{out=out.normalize('NFD').replace(/[\u0300-\u036f]/g,'')}catch(e){}
    return out.replace(/[\u2019\u2018]/g,"'").replace(/\s+/g,' ');
  }

  function cleanModel(value){
    return String(value||'').replace(/^Apple\s+/i,'').replace(/^Réparation\s+/i,'').trim();
  }

  function canonicalModel(value){
    var wanted=norm(cleanModel(value));
    if(!wanted)return '';
    var keys=Object.keys(IMAGE_MAP).sort(function(a,b){return b.length-a.length});
    for(var i=0;i<keys.length;i++){
      var candidate=norm(keys[i]);
      if(wanted===candidate)return keys[i];
    }
    for(var j=0;j<keys.length;j++){
      var c=norm(keys[j]);
      if(wanted.indexOf(c)>-1||c.indexOf(wanted)>-1)return keys[j];
    }
    return cleanModel(value);
  }

  function slug(value){
    return norm(value).replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'');
  }

  function imageFromProduct(product){
    if(!product)return '';
    var image=product.featured_image;
    if(image&&typeof image==='object')image=image.url||image.src;
    if(!image&&product.image)image=typeof product.image==='string'?product.image:(product.image.url||product.image.src);
    if(!image&&product.images&&product.images.length){
      image=product.images[0];
      if(image&&typeof image==='object')image=image.url||image.src;
    }
    return String(image||'').trim();
  }

  function looksLikeRepairProduct(product){
    var text=norm([product&&product.title,product&&product.handle,product&&product.product_type].filter(Boolean).join(' '));
    return text.indexOf('reparat')!==-1||text.indexOf('tarif')!==-1||text.indexOf('diagnostic')!==-1;
  }

  async function dynamicImageForModel(model){
    var modelSlug=slug(model);
    var handles=['apple-'+modelSlug,modelSlug];
    for(var i=0;i<handles.length;i++){
      try{
        var response=await fetch(base+'products/'+handles[i]+'.js',{credentials:'same-origin',cache:'no-store',headers:{'Accept':'application/json'}});
        if(response.ok){
          var product=await response.json();
          if(!looksLikeRepairProduct(product)){
            var direct=imageFromProduct(product);
            if(direct)return direct;
          }
        }
      }catch(e){}
    }
    try{
      var response2=await fetch(base+'search/suggest.json?q='+encodeURIComponent(model)+'&resources[type]=product&resources[limit]=20',{credentials:'same-origin',cache:'no-store',headers:{'Accept':'application/json'}});
      if(response2.ok){
        var data=await response2.json();
        var products=data&&data.resources&&data.resources.results&&data.resources.results.products?data.resources.results.products:[];
        var wanted=norm(cleanModel(model));
        var exact=products.find(function(product){return !looksLikeRepairProduct(product)&&norm(cleanModel(product.title||''))===wanted});
        if(exact){var exactImage=imageFromProduct(exact);if(exactImage)return exactImage}
      }
    }catch(e){}
    return '';
  }

  function imageForModel(model){
    var canonical=canonicalModel(model);
    if(IMAGE_MAP[canonical])return Promise.resolve(IMAGE_MAP[canonical]);
    var key=norm(canonical||model);
    if(!key)return Promise.resolve('');
    if(dynamicCache[key])return Promise.resolve(dynamicCache[key]);
    if(pending[key])return pending[key];
    pending[key]=dynamicImageForModel(canonical||model).then(function(url){
      delete pending[key];
      if(url)dynamicCache[key]=url;
      return url||'';
    }).catch(function(){delete pending[key];return ''});
    return pending[key];
  }

  function injectStyles(){
    if(!document.getElementById('mxp-repair-model-image-style')){
      var style=document.createElement('style');
      style.id='mxp-repair-model-image-style';
      style.textContent=''
        +'#CartDrawer .mxp-drawer-line--repair .mxp-drawer-media.mxp-drawer-media--model-phone{width:58px!important;height:58px!important;display:grid!important;place-items:center!important;overflow:hidden!important;padding:0!important;border:1px solid #e1e4e8!important;border-radius:14px!important;background:linear-gradient(180deg,#fff 0%,#f7f8fa 100%)!important;color:inherit!important;box-shadow:0 4px 12px rgba(17,18,22,.05)!important}'
        +'#CartDrawer .mxp-drawer-line--repair .mxp-drawer-media.mxp-drawer-media--model-phone img{width:100%!important;height:100%!important;display:block!important;object-fit:contain!important;object-position:center!important;padding:3px!important;margin:0!important;filter:drop-shadow(0 3px 4px rgba(17,18,22,.10))!important}'
        +'[data-mxp3] .mxp3repairmedia.mxp3repairmedia--model-phone{width:86px!important;height:86px!important;display:grid!important;place-items:center!important;overflow:hidden!important;padding:0!important;border:1px solid #e1e4e8!important;border-radius:16px!important;background:linear-gradient(180deg,#fff 0%,#f7f8fa 100%)!important;box-shadow:0 6px 18px rgba(17,18,22,.055)!important}'
        +'[data-mxp3] .mxp3repairmedia.mxp3repairmedia--model-phone img{width:100%!important;height:100%!important;display:block!important;object-fit:contain!important;object-position:center!important;padding:3px!important;margin:0!important;filter:drop-shadow(0 4px 5px rgba(17,18,22,.10))!important}'
        +'[data-mxp3] .mxp3repairmedia.mxp3repairmedia--model-phone:after{display:none!important}'
        +'@media(max-width:650px){#CartDrawer .mxp-drawer-line--repair .mxp-drawer-media.mxp-drawer-media--model-phone{width:52px!important;height:52px!important;border-radius:12px!important}#CartDrawer .mxp-drawer-line--repair .mxp-drawer-media.mxp-drawer-media--model-phone img{padding:2px!important}[data-mxp3] .mxp3repairmedia.mxp3repairmedia--model-phone{width:68px!important;height:68px!important;border-radius:13px!important}[data-mxp3] .mxp3repairmedia.mxp3repairmedia--model-phone img{padding:2px!important}}';
      document.head.appendChild(style);
    }

    if(!document.getElementById('mxp-repair-transport-choice-style')){
      var transportStyle=document.createElement('style');
      transportStyle.id='mxp-repair-transport-choice-style';
      transportStyle.textContent=''
        +'#CartDrawer .mxp-repair-transport-source,[data-mxp3] .mxp3-repair-transport-source{display:none!important}'
        +'#CartDrawer .mxp-repair-transport-visual,[data-mxp3] .mxp3-repair-transport-visual{display:inline-flex!important;align-items:center!important;gap:8px!important;max-width:100%!important;padding:7px 9px!important;border:1px solid #e2e5e9!important;border-radius:10px!important;background:#f8f9fa!important;color:#252a30!important;line-height:1.15!important}'
        +'#CartDrawer .mxp-repair-transport-visual{flex-basis:100%!important}'
        +'#CartDrawer .mxp-repair-transport-visual__icon,[data-mxp3] .mxp3-repair-transport-visual__icon{display:grid!important;place-items:center!important;flex:0 0 27px!important;width:27px!important;height:27px!important;border-radius:8px!important;background:#fff2b8!important;color:#111216!important}'
        +'#CartDrawer .mxp-repair-transport-visual__icon svg,[data-mxp3] .mxp3-repair-transport-visual__icon svg{width:15px!important;height:15px!important;display:block!important;stroke:currentColor!important}'
        +'#CartDrawer .mxp-repair-transport-visual__copy,[data-mxp3] .mxp3-repair-transport-visual__copy{display:flex!important;flex-direction:column!important;gap:2px!important;min-width:0!important}'
        +'#CartDrawer .mxp-repair-transport-visual__copy strong,[data-mxp3] .mxp3-repair-transport-visual__copy strong{color:#20242a!important;font-size:9.5px!important;font-weight:950!important;line-height:1.2!important}'
        +'#CartDrawer .mxp-repair-transport-visual__copy small,[data-mxp3] .mxp3-repair-transport-visual__copy small{color:#737981!important;font-size:8.5px!important;font-weight:700!important;line-height:1.25!important}'
        +'[data-mxp3] .mxp3-repair-transport-visual{display:none!important}'
        +'[data-mxp3] .mxp3line[data-mxp-repair-line="true"] .mxp3badge{display:none!important}'
        +'[data-mxp3] .mxp3line[data-mxp-repair-line="true"] .mxp3repairprice__label{display:none!important}'
        +'[data-mxp3] .mxp3line[data-mxp-repair-line="true"] .mxp3price.mxp3repairprice{padding:8px 14px!important}';
      document.head.appendChild(transportStyle);
    }
  }

  function attrModel(line){
    var stored=cleanModel(line.getAttribute('data-mxp-repair-model')||'');
    if(stored)return canonicalModel(stored);
    var rows=Array.prototype.slice.call(line.querySelectorAll('.mxp3attr'));
    for(var i=0;i<rows.length;i++){
      var label=rows[i].querySelector('span');
      var value=rows[i].querySelector('strong');
      if(label&&value&&norm(label.textContent).indexOf('modele')!==-1)return canonicalModel(value.textContent);
    }
    return '';
  }

  function mainModel(line){
    var attr=attrModel(line);if(attr)return attr;
    var title=line.querySelector('.mxp3name');
    return canonicalModel(String(title&&title.textContent||''));
  }

  function drawerModel(line){
    var stored=cleanModel(line.getAttribute('data-mxp-repair-model')||'');
    if(stored)return canonicalModel(stored);
    var title=line.querySelector('.mxp-drawer-title');
    return canonicalModel(String(title&&title.textContent||''));
  }

  function isMainRepair(line){
    if(!line)return false;
    if(line.getAttribute('data-mxp-repair-line')==='true'||line.classList.contains('mxp3line--repair-polished')||line.querySelector('.mxp3repairmedia'))return true;
    var text=norm(line.textContent);
    return !!line.querySelector('.mxp3serviceicon')&&text.indexOf('reparation')!==-1;
  }

  function mountImage(media,url,model,drawer){
    if(!media||!url)return;
    var signature=norm(model)+'|'+url;
    var existing=media.querySelector('img');
    if(media.getAttribute('data-mxp-model-image')===signature&&existing&&existing.getAttribute('src')===url)return;

    var image=new Image();
    image.alt=model;
    image.decoding='async';
    image.loading=drawer?'lazy':'eager';
    image.onload=function(){
      if(!media.isConnected)return;
      media.setAttribute('data-mxp-model-image',signature);
      media.setAttribute('data-mxp-repair-model',model);
      media.innerHTML='';
      if(drawer){
        media.classList.remove('mxp-drawer-media--service','mxp-drawer-media--empty');
        media.classList.add('mxp-drawer-media--model-phone');
      }else{
        media.classList.remove('mxp3serviceicon');
        media.classList.add('mxp3repairmedia','mxp3repairmedia--model-phone','is-ready');
      }
      media.appendChild(image);
    };
    image.src=url;
  }

  function decorateMain(){
    Array.prototype.slice.call(document.querySelectorAll('[data-mxp3] .mxp3line')).forEach(function(line){
      if(!isMainRepair(line))return;
      var model=mainModel(line);if(!model)return;
      line.setAttribute('data-mxp-repair-model',model);
      var media=line.querySelector('.mxp3repairmedia,.mxp3serviceicon');
      if(!media)return;
      imageForModel(model).then(function(url){if(url)mountImage(media,url,model,false)});
    });
  }

  function decorateDrawer(){
    Array.prototype.slice.call(document.querySelectorAll('#CartDrawer .mxp-drawer-line--repair')).forEach(function(line){
      var model=drawerModel(line);if(!model)return;
      line.setAttribute('data-mxp-repair-model',model);
      var media=line.querySelector('.mxp-drawer-media');if(!media)return;
      imageForModel(model).then(function(url){if(url)mountImage(media,url,model,true)});
    });
  }

  function isRemoteTransportText(value){
    var text=norm(value);
    return text.indexOf('distance')!==-1||text.indexOf('mondial relay')!==-1||text.indexOf('chronopost')!==-1||/\bups\b/.test(text);
  }

  function transportVisual(){
    return '<span class="mxp-repair-transport-visual" data-mxp-repair-transport-choice="true"><span class="mxp-repair-transport-visual__icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h11v10H3z"></path><path d="M14 10h3l3 3v3h-6z"></path><circle cx="7" cy="18" r="2"></circle><circle cx="17" cy="18" r="2"></circle></svg></span><span class="mxp-repair-transport-visual__copy"><strong>Transporteur au choix</strong><small>Chronopost ou Mondial Relay à l’étape Livraison</small></span></span>';
  }

  function decorateDrawerTransport(){
    Array.prototype.slice.call(document.querySelectorAll('#CartDrawer .mxp-drawer-line--repair')).forEach(function(line){
      var container=line.querySelector('.mxp-repair-details');
      if(!container||container.querySelector('[data-mxp-repair-transport-choice="true"]'))return;
      var source=Array.prototype.slice.call(container.querySelectorAll('.mxp-repair-detail')).find(function(detail){return isRemoteTransportText(detail.textContent)});
      if(!source)return;
      source.classList.add('mxp-repair-transport-source');
      source.insertAdjacentHTML('afterend',transportVisual());
    });
  }

  function scan(){
    injectStyles();
    decorateMain();
    decorateDrawer();
    decorateDrawerTransport();
  }

  function queue(){
    if(queued)return;
    queued=true;
    requestAnimationFrame(function(){queued=false;scan()});
  }

  function burst(){
    queue();
    setTimeout(queue,40);
    setTimeout(queue,120);
    setTimeout(queue,320);
    setTimeout(queue,800);
  }

  function watch(root){
    if(!root||root.getAttribute('data-mxp-model-image-watch')==='true')return;
    root.setAttribute('data-mxp-model-image-watch','true');
    new MutationObserver(queue).observe(root,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['class','data-mxp-multi-group','data-key']});
  }

  function start(){
    injectStyles();
    watch(document.getElementById('CartDrawer'));
    Array.prototype.slice.call(document.querySelectorAll('[data-mxp3]')).forEach(watch);
    document.addEventListener('cart:updated',burst);
    document.addEventListener('cart:refresh',burst);
    document.addEventListener('mxp:cart-drawer-rendered',burst);
    document.addEventListener('mxp:repair-groups-rendered',burst);
    document.addEventListener('click',function(event){
      var opener=event.target.closest&&event.target.closest('[data-panel-open="CartDrawer"]');
      if(opener)burst();
    },true);
    window.addEventListener('pageshow',burst);
    scan();
    burst();
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();